
import { Component, Mixins, Prop } from 'vue-property-decorator'

import CustomTagMixin from '@/@next/mixins/CustomTag'
import { CImage } from '@/@next/components/image'
import { CLoader } from '@/components/loader'
// import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'
import { messages } from '@/@next/i18n'
import { CButton, CButtonLabel, CButtonIcon } from '@/components/form-controls/button'

const config = {
  name: 'c-content-embed-link',
  i18n: { messages },
  components: {
    CImage,
    CLoader,
    CButton,
    CButtonLabel,
    CButtonIcon
  }
}

@Component(config)
export default class EmbedLink extends Mixins(CustomTagMixin) {
  @Prop({ type: Object, required: true }) content!: any
  @Prop({ type: String, required: false, default: '' }) contextId!: string
  
  // url: string = 'https://maison-du-projet.wivi.io/excavation'

  get text () {
    if (!this.content) return null
    return this.content.data.i18n.text?.value || null
  }

  get textButton () {
    if (!this.content) return null
    return this.content.data.i18n.textButton?.value || null
  }

  get url () {
    if (!this.content) return null
    return this.content.data.i18n.url?.value || null
  }

  get to () {
    return {
      name: 'embeds',
      query: { url: this.url, context: 'poi', contextId: this.contextId, fullscreen: 'true' }
    }
  }

  get styles () {
    return this.content.data?.options?.styles || {}
  }

}
